import { FC, useEffect } from 'react';

const toggleBodyOverflow = (
  isDisabled: boolean,
  calculateScrollOffset?: boolean,
): void => {
  if (!document) return;
  const { body } = document;
  const className = 'disableScroll';
  if (!calculateScrollOffset) {
    body.classList.toggle(className, isDisabled);
  }

  if (calculateScrollOffset) {
    if (isDisabled) {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      body.style.setProperty('--position', `-${scrollY}px`);
      body.classList.add(className);
    }
    if (!isDisabled) {
      const scrollY = Math.abs(
        parseInt(body.style.getPropertyValue('--position') || '0', 10),
      );
      body.style.removeProperty('--position');
      body.classList.remove(className);
      window.scrollTo(0, scrollY);
    }
  }
};

/**
 * Keeps track of how many times the scroll lock is rendered so that
 * once the count reaches 0, the scroll lock can be removed.
 */
let globalScrollLockCount = 0;

type ScrollLockProps = {
  calculateScrollOffset?: boolean;
};

/**
 * Disables scrolling the body while this component is rendered.
 */
const ScrollLock: FC<ScrollLockProps> = ({ calculateScrollOffset }) => {
  useEffect(() => {
    globalScrollLockCount += 1;
    toggleBodyOverflow(true, calculateScrollOffset);
    return () => {
      globalScrollLockCount -= 1;
      if (globalScrollLockCount === 0) {
        toggleBodyOverflow(false, calculateScrollOffset);
      }
    };
  }, [calculateScrollOffset]);

  return null;
};

export default ScrollLock;
